export default{
    methods: {
        $can(permission){
            let accept = false
            let permissions = localStorage.getItem('ccups');
            if(permissions){
                accept = permissions.includes(permission)
            }else{
                accept = false
            }
            // console.log(accept)
            return accept
        }
    },
}